export const RoutePathQueryParamsEnum = {
  QueryParamNameForModalPopup: 'mpp',
  QueryParamValueForCreateTicketModalPopup: 'create-ticket',
  QueryParamValueForCreateCaseModalPopup: 'create-case',
} as const;

export const RoutePathSuffixEnum = {
  RecordId: ':recordId',
  Empty: '',
  Dash: '-',
  Fallback: '*',
  NotRegistered: '/not-registered',
} as const;

export const RoutePathsEnum = {
  Home: '/',
  Settings: '/settings',
  Help: '/help',
  NotificationSettings: '/notification-settings',
  NotificationSettingsPublisherUpdates: '/notification-settings/publisher-updates',
  NotificationSettingsBackup: '/notification-settings/backup',
  Error401: '/401',
  Error403: '/403',
  Error404: '/404',
  Error500: '/500',

  Automation: '/automation',
  Provisioning: '/provisioning',
  AuditLogs: '/audit-logs',
  RequestsDashboard: '/requests/dashboard',

  Reports: '/reports',
  ReportRequests: '/reports/requests',
  ReportsAvailableReports: '/reports/available-reports',
  ReportsAvailableReportsPartial: 'available-reports',
  ReportsActiveReports: '/reports/active-reports',
  ReportsActiveReportsPartial: 'active-reports',
  ReportsActiveReportView: `/reports/active-reports/${RoutePathSuffixEnum.RecordId}`,

  ServiceRequestCreate: '/service-request',
  ServiceRequestDetails: `/service-request/${RoutePathSuffixEnum.RecordId}`,

  PublisherUpdates: '/publisher-updates',
  PublisherUpdatesDashboard: '/publisher-updates/dashboard',
  PublisherUpdatesDetails: `/publisher-updates/${RoutePathSuffixEnum.RecordId}`,
  PublisherUpdatesDetailsContracts: `/publisher-updates/${RoutePathSuffixEnum.RecordId}/contracts`,
  PublisherUpdatesDetailsFiles: `/publisher-updates/${RoutePathSuffixEnum.RecordId}/files`,

  SupportSystemHome: '/service-now',
  SupportSystemTicketsCompany: '/service-now/tickets-company',
  SupportSystemTicketsCompanyPartial: 'tickets-company',
  SupportSystemTicketsIndividual: '/service-now/tickets-individual',
  SupportSystemTicketsIndividualPartial: 'tickets-individual',
  SupportSystemTicketDetail: `/service-now/ticket/${RoutePathSuffixEnum.RecordId}`,
  SupportSystemTicketDetailPartial: `ticket/${RoutePathSuffixEnum.RecordId}`,
  CasesCompany: '/service-now/cases-company',
  CasesCompanyPartial: 'cases-company',
  CasesIndividual: '/service-now/cases-individual',
  CasesIndividualPartial: 'cases-individual',
  CaseDetail: `/service-now/case/${RoutePathSuffixEnum.RecordId}`,
  CaseDetailPartial: `case/${RoutePathSuffixEnum.RecordId}`,

  EscalationDetail: `/service-now/escalation/${RoutePathSuffixEnum.RecordId}`,
  EscalationDetailPartial: `escalation/${RoutePathSuffixEnum.RecordId}`,

  MyProjects: '/my-projects',
  MyProjectsDashboard: '/my-projects/dashboard',
} as const;

export type RoutePathsEnumType = (typeof RoutePathsEnum)[keyof typeof RoutePathsEnum];
